import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';

import {ProductAction, RedeemAction} from 'AppAction';
import Dispatcher from 'service/Dispatcher';

class ProductStore extends ReduceStore {

	constructor() {
		super(Dispatcher);

		this.RECENT_PRODUCTS_PAGINATION = "RECENT_PRODUCTS_PAGINATION";
		this.PRODUCT_DETAIL = "PRODUCT_DETAIL";
		this.PRODUCT_STAT = "PRODUCT_STAT";
		this.ALL_PRODUCTS = "ALL_PRODUCTS";
	}

	getInitialState() {
		return Immutable.Map();
	}

	getFeaturedProducts() {
		return this.getState().get(ProductAction.LOAD_FEATURED_PRODUCTS) || null;
	}

	getPopularProducts() {
		return this.getState().get(ProductAction.LOAD_POPULAR_PRODUCTS) || null;
	}

	getDashainFeaturedProducts() {
		return this.getState().get(ProductAction.LOAD_DASHAIN_FEATURED_PRODUCTS) || null;
	}

	getRecentProducts() {
		return this.getState().get(ProductAction.LOAD_RECENT_PRODUCTS) || null;
	}

	getRecentProductsPagination() {
		return this.getState().get(this.RECENT_PRODUCTS_PAGINATION) || {nextPageNumber: 0, hasMore: true};
	}

	getRecentProductsPerType() {
		return this.getState().get(ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE) || null;
	}

	//Takes a creator object
	getCreatorProducts(creator) {
		if(creator.storeName)
			return this.getStoreProducts(creator.storeName);
		else
			return this.getProducts(creator.id);
	}

	getProducts(userId) {
		const products = this.getState().get(ProductAction.LOAD_USER_PRODUCTS+"_"+userId) || null;
		return products;
	}

	getStoreProducts(storeName) {
		return this.getState().get(ProductAction.LOAD_STORE_PRODUCTS+"_"+storeName) || null;
	}

	getProduct(productId) {
		return this.getState().get(this.PRODUCT_DETAIL+"_"+productId) || null;
	}

	getProductStat(productId) {
		return this.getState().get(this.PRODUCT_STAT+"_"+productId) || null;
	}

	getAllProducts(productState) {
		return this.getState().get(this.ALL_PRODUCTS+"_"+productState) || null;
	}

	getTagProducts(tagName) {
		const tagProducts = this.getState().get(ProductAction.LOAD_TAG_PRODUCTS+"_"+tagName) || null;
		return tagProducts;
	}

	getProductsByType(productType) {
		return this.getState().get(ProductAction.LOAD_TYPE_PRODUCTS+"_"+productType) || null;
	}

	getProductsByTypeForUser(userId, productType) {
		return this.getState().get(ProductAction.LOAD_USER_PRODUCTS_PER_TYPE+"_" + userId + "_" + productType) || null;
	}

	getProductsByTypePagination(productType) {
		const pagination = this.getState().get(ProductAction.LOAD_TYPE_PRODUCTS+"_"+productType+"_pagination") || {nextPageNumber: 0, hasMore: true};
		return pagination;
	}

	getSearchProducts(keyword) {
		return this.getState().get(ProductAction.SEARCH_PRODUCTS+"_"+keyword.toLowerCase()) || null;
	}
	
	getDiscountedProducts(userId) {
		return this.getState().get(ProductAction.LOAD_DISCOUNTED_PRODUCTS+"_"+userId) || null;
	}

	_updateState(state, key, data) {
		return state.set(key, data);
	}

	updateProducts(products, state){
		for (var i in products)
			state = this.updateProduct(products[i], state);

		return state;
	}

	updateProduct(product, state){
		return state.set(this.PRODUCT_DETAIL+"_"+product.id, product);
	}

	reduce(state, action) {
		switch (action.type) {
			case ProductAction.LOAD_FEATURED_PRODUCTS:
				const updatedFeaturedProductState = this._updateState(state, action.type, action.products);
				return this.updateProducts(action.products, updatedFeaturedProductState);

			case ProductAction.LOAD_POPULAR_PRODUCTS:
				const updatedPopularProductState = this._updateState(state, action.type, action.products);
				return this.updateProducts(action.products, updatedPopularProductState);

			case ProductAction.LOAD_DASHAIN_FEATURED_PRODUCTS:
				return this._updateState(state, action.type, action.products)

			case ProductAction.LOAD_RECENT_PRODUCTS:
				const currentRecentProducts = this.getRecentProducts();

				let newRecentProducts = null;
				if(currentRecentProducts === null) {
					newRecentProducts = action.products;
				} else {
					//since its recent products list i.e. they are ordered ib id in desc, we can only add records that are smaller in id with our last current record
					const isProductListNew = action.products.length > 0 && action.products[0].id < currentRecentProducts[currentRecentProducts.length - 1].id;
					newRecentProducts = isProductListNew? currentRecentProducts.concat(action.products): currentRecentProducts;
				}

				const nextPageNumber = action.nextPageNumber;
				const hasMore = action.products.length >= action.pageSize;

				const updatedState = this._updateState(state, action.type, newRecentProducts)
									.set(this.RECENT_PRODUCTS_PAGINATION, {nextPageNumber: nextPageNumber, hasMore: hasMore});
				
				return this.updateProducts(newRecentProducts, updatedState);
			
			case ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE:
				return state.set(ProductAction.LOAD_RECENT_PRODUCTS_PER_TYPE, action.products);

			case ProductAction.UPLOAD_NEW_PRODUCT:
				return state.set(ProductAction.LOAD_USER_PRODUCTS+"_"+action.userId, null);

			case ProductAction.LOAD_USER_PRODUCTS:
				const userId = action.userId;
				const userProductsState = this._updateState(state, action.type+"_"+userId, action.products);
				return this.updateProducts(action.products, userProductsState);
			
			case ProductAction.LOAD_STORE_PRODUCTS:
				const storeName = action.storeName;
				const storeProductsState = this._updateState(state, action.type+"_"+storeName, action.products);
				return this.updateProducts(action.products, storeProductsState);

			case ProductAction.LOAD_SINGLE_PRODUCT:
				return this.updateProduct(action.product, state);

			case ProductAction.LOAD_PRODUCT_STAT:
				return state.set(this.PRODUCT_STAT+"_"+action.productId, action.productStat);

			case ProductAction.LOAD_ALL_PRODUCTS:
				const updateAllProductsState = state.set(this.ALL_PRODUCTS+"_"+action.productState, action.products);
				return this.updateProducts(action.products, updateAllProductsState);

			case ProductAction.LOAD_TAG_PRODUCTS:
				const updatedTagProductsState = this._updateState(state, action.type+"_"+action.tag, action.products);
				return this.updateProducts(action.products, updatedTagProductsState);

			case ProductAction.LOAD_TYPE_PRODUCTS:
				const currentProductsByType = this.getProductsByType(action.productType);

				let newProductsByType = null;
				if(currentProductsByType === null) {
					newProductsByType = action.products;
				} else {
					//since its recent products list i.e. they are ordered ib id in desc, we can only add records that are smaller in id with our last current record
					const isProductListType = action.products.length > 0 && action.products[0].id < currentProductsByType[currentProductsByType.length - 1].id;
					newProductsByType = isProductListType? currentProductsByType.concat(action.products): currentProductsByType;
				}

				const updatedTypeProductsState = state.set(ProductAction.LOAD_TYPE_PRODUCTS+"_"+action.productType, newProductsByType)
													.set(ProductAction.LOAD_TYPE_PRODUCTS+"_"+action.productType+"_pagination", 
															{nextPageNumber: action.nextPageNumber, 
																hasMore: action.products.length >= action.pageSize});

				return this.updateProducts(action.products, updatedTypeProductsState);

			case ProductAction.SEARCH_PRODUCTS:
				const updatedSearchProductsState = state.set(action.type+"_"+action.keyword.toLowerCase(), action.products);
				return this.updateProducts(action.products, updatedSearchProductsState);

			case ProductAction.UPDATE_PRODUCT_STATE:
				//create a new map with all products data cleared
				let newStateMap = this.getInitialState();
				state.entrySeq().forEach(e => {
					const key = e[0], value = e[1];

					if(!key.startsWith(this.ALL_PRODUCTS))
						newStateMap = newStateMap.set(key, value);
				});

				return newStateMap;

			case ProductAction.LOAD_DISCOUNTED_PRODUCTS:
				return this._updateState(state, action.type+"_"+action.userId, action.products);

			case ProductAction.LOAD_USER_PRODUCTS_PER_TYPE:
				const currentProductsByTypeForUser = this.getProductsByTypeForUser(action.userId, action.productType);

				let newProducts = null;
				if(currentProductsByTypeForUser === null) {
					newProducts = action.products;
				} else {
					//since its recent products list i.e. they are ordered by id in desc, we can only add records that are smaller in id with our last current record
					const isUpdateList = action.products.length > 0 && action.products[0].id < currentProductsByTypeForUser[currentProductsByTypeForUser.length - 1].id;
					newProducts = isUpdateList? currentProductsByTypeForUser.concat(action.products): currentProductsByTypeForUser;
				}

				const userProductTypeKey = ProductAction.LOAD_USER_PRODUCTS_PER_TYPE+"_"+action.userId+"_"+action.productType;

				const updatedUserTypeProductsState = state.set(userProductTypeKey, newProducts)
															.set(userProductTypeKey+"_pagination", 
																		{nextPageNumber: action.nextPageNumber, hasMore: action.products.length >= action.pageSize});

				return this.updateProducts(action.products, updatedUserTypeProductsState);

			case RedeemAction.REDEEMED:
				//create a new map with product stat data cleared
				let newMap = this.getInitialState();
				state.entrySeq().forEach(e => {
					const key = e[0], value = e[1];

					if(!key.startsWith(this.PRODUCT_STAT))
						newMap = newMap.set(key, value);
				});

				return newMap;
			default:
				break;

		}

		return state;
	}
}


export default new ProductStore();


// WEBPACK FOOTER //
// ./src/stores/ProductStore.js